import {create} from 'zustand';
import {UseDrawerControllerStoreType} from './types';

export const useDrawerControllerStore = create<UseDrawerControllerStoreType>(set => ({
	drawerIndex: undefined,
	setDrawerIndex: index => set({drawerIndex: index}),
	closeDrawer: () => set({drawerIndex: undefined}),
}));
